import { DatasetDropdown } from "components/basic/dropdowns/dataset/DatasetDropdown";
import TimeSpanInputs from "components/fragments/product-template-configurator/ProductTemplateAttributesConfiguration/type-fields/components/TimeSpanInputs";
import { InputNumber, InputNumberChangeEvent } from "primereact/inputnumber";
import React from "react";
import { T } from "services/lang/LanguageService";
import { DatasetStatusIndicatorProps } from "../DatasetStatusIndicatorTypes";

interface GeneralPropertiesEditorProps {
  currentConfig: DatasetStatusIndicatorProps;
  setCurrentConfig: React.Dispatch<React.SetStateAction<DatasetStatusIndicatorProps>>;
  onConfigChange: (newConfig: DatasetStatusIndicatorProps) => void;
}

const GeneralPropertiesEditor = ({
  currentConfig,
  setCurrentConfig,
  onConfigChange,
}: GeneralPropertiesEditorProps) => {
  const handleDatasetChange = (value: string | null) => {
    setCurrentConfig({ ...currentConfig, identifier: value ?? "" });
    onConfigChange({ ...currentConfig, identifier: value ?? "" });
  };

  const handleConfigChange = (e: InputNumberChangeEvent, id: string) => {
    setCurrentConfig({ ...currentConfig, [id]: e.value });
    onConfigChange({ ...currentConfig, [id]: e.value });
  };

  return (
    <div className="flex flex-column gap-3">
      <div className="flex flex-row gap-2">
        <div className="flex flex-column gap-2 w-8">
          <label htmlFor="valueDataset">{T("word.dataset")}</label>
          <DatasetDropdown value={currentConfig.identifier ?? ""} onChange={handleDatasetChange} />
        </div>
      </div>
      <div className="flex flex-wrap md:flex-nowrap gap-3 mb-3">
        <div className="gap-2 w-10 flex flex-column justify-content-center">
          <label>{`${T("word.datasets")} ${T("word.max")} ${T("word.age").toLowerCase()}`}</label>
          <div className="p-inputgroup">
            <TimeSpanInputs
              value={currentConfig.maxAge ?? 0}
              onChange={val => setCurrentConfig({ ...currentConfig, maxAge: val })}
            />
          </div>
        </div>
        <div className="flex flex-column gap-2 w-2">
          <label htmlFor="updateFrequency">{T("load-conf.update-frequency")}</label>
          <InputNumber
            id="updateFrequency"
            value={currentConfig.updateFrequency}
            onChange={e => handleConfigChange(e, "updateFrequency")}
          />
        </div>
      </div>
    </div>
  );
};

export default GeneralPropertiesEditor;
